(() => {
  if (window.__cloudSearchPresearchScrollInit) return;
  window.__cloudSearchPresearchScrollInit = true;

  let isMutating = false;

  function isMobilePanel(root) {
    if (root.classList.contains('cloud-search-results--mobile')) return true;
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function ensureListScroll(root) {
    let list = root.querySelector(':scope > .cloud-search-results__list');

    if (!list) {
      list = document.createElement('div');
      list.className = 'cloud-search-results__list';

      const status = root.querySelector(':scope > [role="status"]');
      if (status) status.insertAdjacentElement('afterend', list);
      else root.prepend(list);
    }

    const blocks = [...root.querySelectorAll(':scope > .results-block')];
    if (blocks.length) {
      isMutating = true;
      blocks.forEach((block) => list.appendChild(block));
      isMutating = false;
    }

    return list;
  }

  /*
   * Cloud Search renders the "Show all results" link as a sibling pinned to the
   * panel/viewport bottom. On mobile that makes it float over results when the
   * keyboard shrinks the viewport. Fold it into the scrollable list so it sits
   * after the last result and can be reached by scrolling.
   */
  function moveSeeMoreIntoList(root, list) {
    if (!list || !isMobilePanel(root)) return;

    const seeMore = root.querySelector(':scope > .see-more-results, :scope > [id$="see-more-results"]');
    if (!seeMore || seeMore.parentElement === list) return;

    isMutating = true;
    list.appendChild(seeMore);
    isMutating = false;
  }

  function getViewportBottom() {
    const vv = window.visualViewport;
    if (vv) return vv.offsetTop + vv.height;
    return window.innerHeight;
  }

  function getScrollBottomLimit() {
    let bottom = getViewportBottom() - 16;

    const mobileChrome = document.querySelector('.cloud-search-mobile');
    if (mobileChrome) {
      const chromeTop = mobileChrome.getBoundingClientRect().top;
      if (chromeTop > 0 && chromeTop < bottom) bottom = chromeTop - 8;
    }

    return bottom;
  }

  function syncScrollMaxHeight(root) {
    const list = root.querySelector(':scope > .cloud-search-results__list');
    if (!list) return;
    if (root.hasAttribute('hidden')) return;

    const listRect = list.getBoundingClientRect();
    const top = listRect.top || root.getBoundingClientRect().top;
    if (!top && top !== 0) return;

    const bottom = getScrollBottomLimit();
    const maxHeight = Math.max(120, bottom - top);

    list.style.maxHeight = `${maxHeight}px`;
  }

  function normalizePanelPosition(root) {
    const transform = root.style.transform;
    if (!transform || transform === 'none') return;

    const match = transform.match(/translate\((\d+(?:\.\d+)?)px,\s*(\d+(?:\.\d+)?)px\)/);
    if (!match) return;

    root.style.left = `${Math.round(parseFloat(match[1]))}px`;
    root.style.top = `${Math.round(parseFloat(match[2]))}px`;
    root.style.transform = 'none';
    root.style.overflow = 'visible';
    root.style.maxHeight = 'none';
  }

  function applyLayout(root) {
    if (!root || root.hasAttribute('hidden')) return;

    normalizePanelPosition(root);
    const list = ensureListScroll(root);
    moveSeeMoreIntoList(root, list);
    syncScrollMaxHeight(root);
    root.dispatchEvent(new CustomEvent('cloud-search-presearch-layout', { bubbles: true }));
  }

  function bind(root) {
    if (!root || root.dataset.scrollBound) return;
    root.dataset.scrollBound = 'true';

    applyLayout(root);

    new MutationObserver(() => {
      if (isMutating) return;
      applyLayout(root);
    }).observe(root, {
      childList: true,
      attributes: true,
      attributeFilter: ['style', 'hidden', 'class'],
    });
  }

  function init() {
    const onViewportChange = () => {
      document.querySelectorAll('#cloud-search-results, .cloud-search-results').forEach(syncScrollMaxHeight);
    };

    document.querySelectorAll('#cloud-search-results, .cloud-search-results').forEach(bind);

    new MutationObserver(() => {
      document.querySelectorAll('#cloud-search-results, .cloud-search-results').forEach((el) => {
        if (!el.dataset.scrollBound) bind(el);
        else applyLayout(el);
      });

      if (document.querySelector('.cloud-search-mobile')) onViewportChange();
    }).observe(document.body, { childList: true, subtree: true });

    window.addEventListener('resize', onViewportChange);
    window.visualViewport?.addEventListener('resize', onViewportChange);
    window.visualViewport?.addEventListener('scroll', onViewportChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
